'use strict';

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
let app = typeof window !== 'undefined' ? window.app : undefined;
const styles = {
  Checkbox: {
    height: '21px',
    width: '21px',
    marginRight: '8px',
    marginLeft: '0'
  },
  label: {
    fontFamily: 'inherit'
  },
  root: {
    marginLeft: '0'
  }
};
class CustomCheckbox extends PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: [true, 'true'].includes(props['default-value']),
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    const {
      checked,
      name
    } = e.target;
    props.onChange({
      e: e,
      value: checked,
      name: name,
      source: 'native'
    });
  };
  render() {
    const component = this,
      props = this.props;
    let class_name = props.className;
    if (props['full-width']) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    let error_msg,
      status = props.status[props.name];
    if (status && status.error) {
      error_msg = /*#__PURE__*/React.createElement(FormHelperText, {
        error: true
      }, status.error);
    }
    let output = /*#__PURE__*/React.createElement("div", {
      className: class_name
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      label: props.label,
      classes: {
        label: props.classes.label,
        root: props.classes.root
      },
      control: /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleChange,
        name: props.name,
        className: props.classes.Checkbox,
        checked: [true, 'true'].includes(props.value),
        color: "primary",
        icon: /*#__PURE__*/React.createElement(CheckBoxOutlineBlankIcon, null),
        id: props.id,
        disabled: props.disabled || props['read-only']
      })
    }), props.children, error_msg);
    return output;
  }
}
CustomCheckbox.propTypes = {
  'default-value': PropTypes.bool,
  'full-width': PropTypes.bool,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  classes: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
CustomCheckbox.defaultProps = {
  'full-width': true,
  'default-value': false,
  className: ''
};
export default withStyles(styles)(CustomCheckbox);
